import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { initializeOAuthClientConfig } from './app/core/auth/auth.constants';

initializeOAuthClientConfig()
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
